import { Box } from '../layout/Box';
import { ModalBodyProps } from './interface-modal';

export const ModalBody = ({ children }: ModalBodyProps) => <Box>{children}</Box>;
